// src/modules/auth/pages/RegisterPage.js

import React from 'react';
import RegisterForm from '../components/RegisterForm';

const RegisterPage = () => {
    return <RegisterForm />;
};

export default RegisterPage;
